<template>
  <img 
    :style="iconStyle" 
    :alt="alt" 
    :srcset="srcset"
    :src="isActive ? activeIcon : inactiveIcon"
    class="menu-icon"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

// 使用 new URL 处理图片路径
const getImageUrl = (imgPath: string) => {
  console.log(imgPath);
  
  // 移除 @ 别名并构建相对路径
  const relativePath = imgPath.replace('@/', '../')
  return new URL(`../../assets/fenlikeimg/menuiicon/${imgPath}`, import.meta.url).href
}

// 定义组件属性
interface Props {
  // 当前激活的路径
  currentPath: string
  // 目标路径（用于判断是否激活）
  targetPath: string
  // 激活状态的图标路径
  activeIcon: string
  // 非激活状态的图标路径
  inactiveIcon: string
  // 图标样式
  iconStyle?: Record<string, any>
  // alt 属性
  alt?: string
  // srcset 属性
  srcset?: string
}

// 设置默认值
const props = withDefaults(defineProps<Props>(), {
  iconStyle: () => ({ width: '20px', height: '20px' }),
  alt: '',
  srcset: ''
})

// 计算激活状态的图标
const activeIcon = computed(() => {
  return getImageUrl(props.activeIcon)
})

// 计算非激活状态的图标
const inactiveIcon = computed(() => {
  return getImageUrl(props.inactiveIcon)
})

// 计算是否为激活状态
const isActive = computed(() => {
  return props.currentPath === props.targetPath
})
</script>

<style lang="less" scoped>
.menu-icon {
  display: inline-block;
  transition: all 0.3s ease;
  
  &:hover {
    opacity: 0.8;
  }
}
</style>